export { default as CrownSolidIcon } from './CrownSolidIcon';
